
import React, { memo, useCallback, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { getStringValueFromGenericInput } from '@shootsta/get-value-from-generic-input';
import { Button, Input, Text } from '../../../../../../ui-kit';
import generatePassword from '../../utils/generatePassword';

import '../../styles/_password-protect.scss';






function PasswordProtect({ onSave, value = '' }) {
  const [copied, setCopied] = useState(false);
  const [password, setPasswordValue] = useState(value);
  const [generatedPassword, setGeneratedPassword] = useState(void 0);

  const generate = useCallback(() => {
    const newPassword = generatePassword();

    setPasswordValue(newPassword);
    setGeneratedPassword(newPassword);
  });

  const onPasswordChange = useCallback(
    (event) => setPasswordValue(getStringValueFromGenericInput(event))
  );

  const onCopySuccess = useCallback(() => {
    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 2000);
  });

  const onSaveClick = useCallback(() => onSave(password), [onSave, password]);

  return (
    <div className="password-protect">
      <div className="password-protect__container">
        <Text>Password</Text>
        <Button
          type="TERTIARY"
          onClick={generate}>

          Generate password
        </Button>
        <Input
          key={generatedPassword}
          placeholder="Enter password"
          defaultValue={password}
          onChange={onPasswordChange}
          suffixIcon={
          <CopyToClipboard
            text={password}
            onCopy={onCopySuccess}>

              <Button
              data-testid="copy-to-clipboard"
              type="TERTIARY"
              prefix={copied ? 'success' : 'duplicate'}
              tooltipId="copy-password-btn"
              tooltipLabel="Copy password" />

            </CopyToClipboard>} />


      </div>
      <Button
        className="password-protect__save-btn"
        type="SECONDARY"
        disabled={!password || password === value}
        onClick={onSaveClick}>

        Save
      </Button>
    </div>);

}

export default memo(PasswordProtect);